export default __webpack_public_path__ + "static/media/yield.827de797.png";